export default function($) {
  $('.js-dropdown-trigger').on('click', function() {
    $(this).parent('.js-dropdown').toggleClass('open');
  });
}
